/* global ApeConfig */
import React from 'react';
import axios from 'axios';
import { Typography, Flex, Spin } from 'antd';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ApeGrid, Item } from './shared/ApeGrid'
import { useDebouncedValue } from './ViewToken'
import { useSockets } from './context/SocketsContext';
import { useGrid } from './context/GridContext';
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

const formatNumber = (value) => {
	return Intl.NumberFormat('en-US', {
		notation: "compact",
		maximumFractionDigits: 1
	}).format(value);
};

const HeroItem = ({ value, isSolo = true }) => {

	const config = ApeConfig.find(x => x.ID === value.chain);
	const chainName = config.Name;

	return (
		<div style={{
			width: '344px',
			height: '184px',
			background: 'linear-gradient(180deg, #FFE814 0%, #E2CE19 13%, #857B29 54.5%, #998B0C 100%)',
			borderRadius: '20px',
			padding: '2px',
			position: 'relative'
		}}>
			<div style={{
				width: '50px',
				height: '50px',
				position: 'absolute',
				top: '-20px',
				left: '-20px',
				zIndex: 1,
				background: 'linear-gradient(180deg, #FFE814 0%, #E2CE19 13%, #857B29 54.5%, #998B0C 100%)',
				borderRadius: '50%',
				padding: '2px',
			}}>
				<div style={{
					backgroundColor: '#191a1a',
					borderRadius: '50%',
					padding: 0,
					width: '100%',
					height: '100%'
				}}>
					<img alt="King of Apes" style={{ width: '46px', height: '46px'}} src="/img/crown.png" />
				</div>
			</div>
			<Text style={{
				position: 'absolute',
				top: '-30px',
				paddingLeft: '35px',
				left: 0,
				fontSize: '17px',
				fontWeight: 500,
				lineHeight: '20.57px',
				textAlign: 'left',
			}}>King Of {isSolo ? "Apes" : chainName}</Text>
			<Item value={value} isKing={true} />
		</div>
	);
}

const FreeItem = ({ value }) => {
	return (
		<div style={{
			width: '344px',
			height: '184px',
			background: 'linear-gradient(270.06deg, #86EFAC -20.5%, #4D8963 78.59%)',
			borderRadius: '20px',
			padding: '2px',
			position: 'relative'
		}}>
			<div style={{
				width: '50px',
				height: '50px',
				position: 'absolute',
				top: '-20px',
				left: '-20px',
				zIndex: 1,
				background: 'linear-gradient(270.06deg, #86EFAC -20.5%, #4D8963 78.59%)',
				borderRadius: '50%',
				padding: '2px',
			}}>
				<div style={{
					backgroundColor: '#191a1a',
					borderRadius: '50%',
					padding: 0,
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}>
					<img alt="Recently Freed" style={{ width: '40px', height: '30px' }} src="/img/logo.png" />
				</div>
			</div>
			<Text style={{
				position: 'absolute',
				top: '-30px',
				paddingLeft: '35px',
				left: 0,
				fontSize: '17px',
				fontWeight: 500,
				lineHeight: '20.57px',
				textAlign: 'left',
			}}>Recently Freed</Text>
			<Item value={value} isKing={true} />
		</div>
	);
}



const TrendingItem = ({ value }) => {
	const navigate = useNavigate();

	const lookupChain = (chain) => {
		return ApeConfig.find(x => x.Short === chain || x.ID === chain)?.Short ?? chain;
	}

	return (
		<div style={{
			width: '344px',
			height: '184px',
			background: 'linear-gradient(270.03deg, #FFAD07 0%, #FFC702 78.59%)',
			borderRadius: '20px',
			padding: '2px',
			position: 'relative'
		}}>
			<div style={{
				width: '50px',
				height: '50px',
				position: 'absolute',
				top: '-20px',
				left: '-20px',
				zIndex: 1,
				background: 'linear-gradient(270.03deg, #FFAD07 0%, #FFC702 78.59%)',
				borderRadius: '50%',
				padding: '2px'
			}}>
				<div style={{
					backgroundColor: '#191a1a',
					borderRadius: '50%',
					padding: 0,
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}>
					<img alt="Trending" style={{ width: '40px', height: '40px' }} src="/img/trending.png" />
				</div>
			</div>
			<Text style={{
				position: 'absolute',
				top: '-30px',
				paddingLeft: '35px',
				left: 0,
				fontSize: '17px',
				fontWeight: 500,
				lineHeight: '20.57px',
				textAlign: 'left',
			}}>Trending</Text>
					<div style={{
						width: '340px',
						height: '180px',
						borderRadius: '18px',
						background: '#161721',
						marginBottom: '20px',
						border:'none'
			}}>
				<Flex justify="space-between" style={{ height: '100%', width: '100%', padding: '20px' }}>
					<Flex vertical justify="center" align="center" style={{ width: '100%' }}>
						{value.map((token, index) => {
							return (
								<a key={`trending_${token.address}`} href={`/${lookupChain(token.chain)}/${token.address}`} onClick={(evt) => {
									if (!evt.shiftKey && !evt.ctrlKey) {
										evt.preventDefault();
										navigate(`/${lookupChain(token.chain)}/${token.address}`);
									}
								}} style={{ color: index === 0 ? "gold" : index === 1 ? "#fff" : index === 2 ? "#cd7f32" : "gray" }}>
									<Flex align="center" style={{ width: '300px' }} gap={10} justify="space-between">
										<Flex justify="flex-start">
											<div style={{ width: '20px'}}>{index + 1}</div>
											<div style={{ overflow: 'hidden', maxWidth: '100px' }}>{token.symbol}</div>
										</Flex>
										<Flex justify="flex-end">
											<div>{`MC: ${formatNumber(token.mCapUsd)} / Vol 1h: ${formatNumber(token.volumeUsd)}`}</div>
											{/*<div style={{ width: '30px', textAlign: 'right' }}>UP</div>*/}
										</Flex>								
									</Flex>
								</a>
							);
						})}
					</Flex>
				</Flex>
			</div>
		</div>
	);
}



const LeaderboardItem = ({ value }) => {
	const navigate = useNavigate();

	const lookupChain = (chain) => {
		return ApeConfig.find(x => x.Short === chain || x.ID === chain)?.Short ?? chain;
	}

	return (
		<div style={{
			width: '344px',
			height: '184px',
			background: 'linear-gradient(270.03deg, #285DE1 0%, #00AAFF 78.59%)',

			borderRadius: '20px',
			padding: '2px',
			position: 'relative'
		}}>
			<div style={{
				width: '50px',
				height: '50px',
				position: 'absolute',
				top: '-20px',
				left: '-20px',
				zIndex: 1,
				background: 'linear-gradient(270.03deg, #285DE1 0%, #00AAFF 78.59%)',
				borderRadius: '50%',
				padding: '2px'
			}}>
				<div style={{
					backgroundColor: '#191a1a',
					borderRadius: '50%',
					padding: 0,
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}>
					<img alt="Leaderboard" style={{ width: '40px', height: '40px' }} src="/img/leaderboard.png" />
				</div>
			</div>
			<Text style={{
				position: 'absolute',
				top: '-30px',
				paddingLeft: '35px',
				left: 0,
				fontSize: '17px',
				fontWeight: 500,
				lineHeight: '20.57px',
				textAlign: 'left',
			}}>Leaderboard</Text>
			<div style={{
				width: '340px',
				height: '180px',
				borderRadius: '18px',
				background: '#161721',
				marginBottom: '20px',
				border: 'none'
			}}>
				<Flex justify="space-between" style={{ height: '100%', width: '100%', padding: '20px' }}>
					<Flex vertical justify="center" align="center" style={{ width: '100%' }}>
						{value.map((token, index) => {
							return (
								<a key={`leaderboard_${token.address}`} href={`/${lookupChain(token.chain)}/${token.address}`} onClick={(evt) => {
									if (!evt.shiftKey && !evt.ctrlKey) {
										evt.preventDefault();
										navigate(`/${lookupChain(token.chain)}/${token.address}`);
									}
								}} style={{ color: index === 0 ? "gold" : index === 1 ? "#fff" : index === 2 ? "#cd7f32" : "gray" }}>
									<Flex align="center" style={{ width: '300px' }} gap={10} justify="space-between">
										<Flex justify="flex-start">
											<div style={{ width: '20px' }}>{index + 1}</div>
											<div style={{ overflow: 'hidden', maxWidth: '100px' }}>{token.symbol}</div>
										</Flex>
										<Flex justify="flex-end">
											<div>{`MC: ${formatNumber(token.mCapUsd)} / Vol 24h: ${formatNumber(token.volumeUsd)}`}</div>
											{/*<div style={{ width: '30px', textAlign: 'right' }}>UP</div>*/}
										</Flex>
									</Flex>
								</a>
							);
						})}
					</Flex>
				</Flex>
			</div>
		</div>
	);
}

const ApeNewsWidget = ({ topTokens, freeTokens, trending, leaderboard }) => {
	return (
		<div style={{ zIndex: 1, position: "relative", background: 'rgb(27, 29, 40)' }}>
			<div style={{
				background: 'url("/img/apebg2.jpg")',
				backgroundSize: 'cover',
				scale: 'crop',
				width: '100%',
				height: '325px',
				opacity: '0.03',
				angle: '-180 deg',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}} />
			<div style={{ position: 'absolute', width: '100%', height: '325px', top: 0 }}>
				<Slider
					infinite={true}
					speed={500}
					slidesToShow={1}
					slidesToScroll={1}
					centerMode={true}
					autoplay={true}
					arrows={false}
					autoplaySpeed={5000}
					centerPadding="10px"
				> 
					{topTokens.map(token => {
						return (
							<div key={token.id} style={{ width: '90%', minWidth: '345px'}}>
								<div style={{ width: '100%', height: '325px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
									<HeroItem value={token} isSolo={topTokens.length <= 1} />
								</div>
							</div>
						);
					})}
					{freeTokens.map(token => {
						return (
							<div key={token.id} style={{ width: '90%', minWidth: '345px' }}>
								<Flex vertical justify="center" align="center" style={{ height: '325px' }}>
									<Flex wrap="wrap" justify="center" align="center" gap={10}>
										<FreeItem value={token} />
									</Flex>
								</Flex>
							</div>
						);
					})}
					{/*{trending.length > 0 ? <div key="trending" style={{ width: '90%', minWidth: '345px' }}>*/}
					{/*	<Flex vertical justify="center" align="center" style={{ height: '325px' }}>*/}
					{/*		<Flex wrap="wrap" justify="center" align="center" gap={10}>*/}
					{/*			<TrendingItem value={trending} />*/}
					{/*		</Flex>*/}
					{/*	</Flex>*/}
					{/*</div> : <></>}*/}
					{/*{leaderboard.length > 0 ? <div key="trending" style={{ width: '90%', minWidth: '345px' }}>*/}
					{/*	<Flex vertical justify="center" align="center" style={{ height: '325px' }}>*/}
					{/*		<Flex wrap="wrap" justify="center" align="center" gap={10}>*/}
					{/*			<LeaderboardItem value={leaderboard} />*/}
					{/*		</Flex>*/}
					{/*	</Flex>*/}
					{/*</div> : <></>}*/}
				</Slider>
			</div>
		</div>	
	);
}

export const Home = () => {
	const { latestToken, latestEvent, refreshRequired, setRefreshRequired } = useSockets();
	const { sort, setSort, chain, setChain, order, setOrder, search, setSearch, filter, setFilter, page, setPage, pages, setPages, isAtBottom } = useGrid();

	const [tokens, setTokens] = React.useState([]);
	const [showLoading, setShowLoading] = React.useState([]);
	const [trending, setTrending] = React.useState([]);
	const [leaderboard, setLeaderboard] = React.useState([]);
	const [topTokens, setTopTokens] = React.useState([]);
	const [freeTokens, setFreeTokens] = React.useState([]);

	const debouncedSearch = useDebouncedValue(search, 500);

	const loadKing = async () => {
		setTopTokens([]);
		const response = await axios.get(`/api/king`);
		setTopTokens(response.data.king);
		setFreeTokens(response.data.free);
		setTrending(response.data.trending);
		setLeaderboard(response.data.leaderboard);
	};

	const newSearch = async () => {
		setTokens([]);
		setPage(0);
		const response = await axios.get(`/api/tokens?page=${page}&sort=${sort}&order=${order}&filter=${filter}&search=${search}&chain=${chain}`);
		setPages(response.data.pageCount);
		setTokens(response.data.items);
	}

	const loadPage = async () => {
		const response = await axios.get(`/api/tokens?page=${page}&sort=${sort}&order=${order}&filter=${filter}&search=${search}&chain=${chain}`);
		setPages(response.data.pageCount);
		setTokens(tokens.concat(response.data.items));
		setShowLoading(false);
	};

	React.useEffect(() => {
		newSearch();
	}, [sort, order, filter, debouncedSearch, chain]);


	React.useEffect(() => {
		
		loadPage();
	}, [page]);


	React.useEffect(() => {
		loadKing();
	}, [])

	React.useEffect(() => {
		if (isAtBottom && tokens.length > 0) {
			setShowLoading(true);
			setPage(page + 1)
		}
	}, [isAtBottom])

	React.useEffect(() => {
		if (refreshRequired) {
			loadPage();
			loadKing();
			setRefreshRequired(false);
		}
	}, [refreshRequired]);

	React.useEffect(() => {

		if (tokens.length === 0) {
			return;
		}
		
		if (latestToken !== null) {
			for (let i = 0; i < topTokens.length; i++) {
				if (latestToken.id === topTokens[i].id) {
					setTopTokens([latestToken, ...topTokens.filter(x => x.chain !== latestToken.chain)]);
				}
			}
			for (let i = 0; i < freeTokens.length; i++) {
				if (latestToken.id === freeTokens[i].id) {
					setFreeTokens([latestToken, ...freeTokens.filter(x => x.chain !== latestToken.chain)]);
				}
			}
		}			

		if (latestToken !== null && page === 0 && sort === 1) {
			const t = tokens.filter(x => x.id !== latestToken.id);
			setTokens([{ animate: true, ...latestToken }, ...t].splice(0, 32));
			// TODO - other sort orders / pages?
		} else {
			setTokens(tokens?.map(el => (el.id === latestToken?.id ? { ...el } : el)));
		}
	}, [latestToken]);

	React.useEffect(() => {
		if (latestEvent?.isNewKing || latestEvent?.isNewFree) {
			console.log("New king detected")
			loadKing();
		}
	}, [latestEvent]);

	return (
		<>			
			<ApeNewsWidget topTokens={topTokens} freeTokens={freeTokens} trending={trending} leaderboard={leaderboard} />	
			<ApeGrid title="Real-time Pairs" items={tokens} page={page} setPage={setPage} sort={sort} setSort={setSort} order={order} setOrder={setOrder} search={search} setSearch={setSearch} filter={filter} setFilter={setFilter} chain={chain} setChain={setChain} pages={pages} isAtBottom={isAtBottom} showPager={false} />
			{showLoading ?
				<div style={{ width: "100%" }} class="page-loading-spinner">
					<Spin size="large" style={{ margin: 'auto', zIndex: 1000 }} />
				</div> :
				<></>
			}
		</>
	);
};
